<template>
    <div class="user-info" @click="handleGoUserIndex">
        <div class="avatar">
            <img class="avatar-box" :src="userInfo.headImg | resizeImgShort(100)" />
        </div>
        <div class="user-detail">
            <p class="user-title">
                <span class="user-nickname">{{userInfo.nickname}}</span>
                <span class="user-gender-box">
                    <gender :gender="userInfo.sex || 1" :age="userInfo.age || 18"></gender>
                </span>
            </p>
            <p class="user-sign">{{userInfo.signature}}</p>
        </div>
        <slot name="operator"></slot>
        <span class="split-line"></span>
    </div>
</template>

<script>
import Gender from "./Gender";
export default {
    name: "UserInfo",
    components: {
        Gender
    },
    props: {
        userInfo: {
            type: Object,
            required: true
        },
        goUserIndex: {
            type: Boolean,
            default: false
        }
    },
    computed: {},

    data() {
        return {};
    },

    methods: {
        handleGoUserIndex() {
            if (this.goUserIndex) {
                let id = this.userInfo.userId;
                this.$router.push({ path: "/personalHome/" + id });
            }
        }
    }
};
</script>

<style scoped lang="scss" >
@import "../../style/function.scss";
@import "../../style/config.scss";

.user-info {
    display: flex;
    background: #fff;
    padding: 0.2rem 0 0.2rem 0.3rem;
    position: relative;
    align-items: center;

    .avatar {
        flex-basis: 0.96rem;

        .avatar-box {
            width: 0.96rem;
            height: 0.96rem;
            border: 1px solid #ccc;
            overflow: hidden;
            border-radius: 50%;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            object-fit: cover;
        }
    }

    .user-detail {
        flex: 1;
        padding-left: 0.3rem;
        overflow: hidden;
    }

    .user-title {
        font-size: 0.28rem;
        color: $baseColor;
        display: flex;
    }

    .user-nickname {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .user-gender-box {
        flex: 1;
        min-width: 0.8rem;
        padding-left: 0.08rem;
    }

    .user-sign {
        font-size: 0.24rem;
        color: $secondaryColor;
        padding-top: 0.1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .split-line {
        position: absolute;
        display: block;
        width: 6rem;
        height: 1px;
        bottom: 0;
        right: 0;
        background: #e5e5e5;
        transform: scaleY(0.5);
    }
}
</style>
